// src/pages/Register.jsx
import PasswordInput from "../common/PasswordInput";
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function Register() {
  const nav = useNavigate();

  const [company, setCompany] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [appVariant, setAppVariant] = useState("STANDARD");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  function normalizeCompany(v) {
    return (v || "").toUpperCase().replace(/[^A-Z0-9_]/g, "");
  }

  async function onSubmit(e) {
    e.preventDefault();
    setError("");

    const c = normalizeCompany(company).trim().toLowerCase();

    if (!c) return setError("Completează compania (ex: ALFA).");
    if (!username.trim()) return setError("Completează username.");
    if (!email.trim()) return setError("Completează adresa de email.");
    if (!/\S+@\S+\.\S+/.test(email))
      return setError("Adresa de email nu este validă.");
    if (!password) return setError("Completează parola.");
    if (password.length < 6)
      return setError("Parola trebuie să aibă minim 6 caractere.");
    if (password !== password2) return setError("Parolele nu coincid.");

    setLoading(true);
    try {
      const res = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          company: c,
          username: username.trim(),
          password,
          email: email.trim(),
          app_variant: appVariant,
          shop_enabled:false,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.detail || data?.message || "Register failed");
      }

      localStorage.setItem("last_company", c);
      nav("/login", {
        state: {
          message:
            data?.message ||
            "Cont înregistrat cu succes! Te rugăm să îți verifici e-mailul pentru a confirma contul și a activa baza de date.",
        },
      });
    } catch (err) {
      setError(err?.message || "Eroare la înregistrare.");
    } finally {
      setLoading(false);
    }
  }

  const variants = [
    { code: "LITE", label: "LITE", desc: "Varianta de baza fara productie" },
    {
      code: "STANDARD",
      label: "STANDARD",
      desc: "Varianta completă inclusiv productie,retete,produse finite",
    },
    { code: "SANTIER", label: "SANTIER", desc: "Firme de construcții: obiective, devize și import Excel" },
    {
      code: "SERVICE_AUTO",
      label: "SERVICE AUTO",
      desc: "Varianta dedicată service-urilor auto",
    },
    {
      code: "CONTOR",
      label: "CONTOR",
      desc: "Varianta dedicată pentru service copiatoare,computere,imprimante",
    },
  ];

  return (
    <div className="container py-4" style={{ maxWidth: 580 }}>
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-body p-4">
          <h3 className="mb-3 fw-bold text-primary">Creează cont / firmă</h3>
          <p className="text-muted small mb-4">
            Înregistrează o firmă nouă și alege varianta de aplicație potrivită. Magazinul WooCommerce se activează separat, numai de superadmin.
          </p>

          {error && (
            <div className="alert alert-danger py-2 rounded-3" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={onSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Companie_reg (cod firmă)
              </label>
              <input
                className="form-control rounded-3"
                value={company}
                onChange={(e) => setCompany(normalizeCompany(e.target.value))}
                placeholder="ALFA"
                autoComplete="organization"
              />
              <div className="form-text">
                Doar A-Z, 0-9 și _ (ex: ALFA, BETA_2026).
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">
                Variantă Aplicație
              </label>
              <div className="border rounded-3 p-3 bg-light">
                {variants.map((v) => (
                  <div key={v.code} className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="appVariantOptions"
                      id={`var-${v.code}`}
                      value={v.code}
                      checked={appVariant === v.code}
                      onChange={(e) => setAppVariant(e.target.value)}
                    />
                    <label
                      className="form-check-label fw-semibold"
                      htmlFor={`var-${v.code}`}
                    >
                      {v.label}{" "}
                      <span className="text-muted fw-normal ms-1">
                        ({v.desc})
                      </span>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Username</label>
              <input
                className="form-control rounded-3"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="alice"
                autoComplete="username"
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Email</label>
              <input
                type="email"
                className="form-control rounded-3"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nume@exemplu.ro"
                autoComplete="email"
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Parolă</label>
              <PasswordInput
                aria-label="Parolă"
                onSuggest={value => { setPassword(value); setPassword2(value); }}
                disabled={loading}
                className="form-control rounded-3"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Confirmă parola</label>
              <input
                type="password"
                className="form-control rounded-3"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                autoComplete="new-password"
              />
            </div>

            <button
              className="btn btn-primary w-100 py-2 rounded-3 fw-bold mt-2"
              disabled={loading}
            >
              {loading ? "Se creează..." : "Înregistrează"}
            </button>

            <div className="text-center mt-3">
              <span className="text-muted">Ai deja cont?</span>{" "}
              <Link to="/login" className="fw-semibold text-decoration-none">
                Login
              </Link>
            </div>
          </form>
        </div>
      </div>

      <div className="text-muted small mt-3 text-center">
        După înregistrare se creează automat baza firmei din template
        configurată pe varianta aleasă.
      </div>
    </div>
  );
}
